import React from 'react';
import {connect} from 'react-redux';
// import { connect } from 'react-redux';
import "react-vis/dist/style.css";
import {
    FlexibleXYPlot,
    LineSeries,
    VerticalGridLines,
    HorizontalGridLines,
    XAxis,
    YAxis,
    CustomSVGSeries,

} from "react-vis";

import {
    getErrorIssues
} from '../../../../../../../utils/validationSummary';

class AdjustableDimChart extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const errorsOff = getErrorIssues(this.props.issues, this.props.propertyOff);
        const errorsOn = getErrorIssues(this.props.issues, this.props.propertyOn);
        const errorsX = getErrorIssues(this.props.issues, this.props.propertyX);
        const errorsY = getErrorIssues(this.props.issues, this.props.propertyY);
        const errorsDim = getErrorIssues(this.props.issues, this.props.propertyDim);

        const totalErrors = errorsOff.length + errorsOn.length + errorsX.length + errorsY.length + errorsDim.length;

        const dimmingLevel = Number(this.props.MinDim);
        var opposite = 0;
        var angleInRadians = 0;
        let xPoint = Number(this.props.Xvoltage);
        let yPoint = Number(this.props.Yvoltage);
        let offPoint = this.props.OFF; //Dim-to-Off On/Off
        let opposite_small = 0;
        let temp1_point = xPoint;
        let temp2_point = 12;
        let temp3_point = 0;
        let show_l1 = true;
        let show_l2 = true;
        let show_l3 = true;
        let show_l4 = true;

        let color_l4 = 'blue';

        if (offPoint === 'Off') {
            show_l1 = false;
            show_l2 = false;
            show_l3 = false;
            color_l4 = 'red';
        }

        if (xPoint < yPoint) {
            if (offPoint === 'Off') {
                offPoint = 0;
            } else {
                if (this.props.ON > this.props.Xvoltage) {
                    angleInRadians = Math.atan((100 - dimmingLevel) / ((this.props.Yvoltage - this.props.Xvoltage) * 10));
                    opposite = (this.props.ON - this.props.Xvoltage) * 10 * Math.tan(angleInRadians);
                }
                if (this.props.Xvoltage < this.props.OFF) {
                    opposite_small = (offPoint - xPoint) * 10 * Math.tan(angleInRadians);
                    temp1_point = offPoint;
                    show_l4 = false;
                }
            }
        } else if (xPoint >= yPoint) {
            temp2_point = 0;
            temp3_point = 12;

            if (offPoint === 'Off') {
                offPoint = 12;
            } else {
                if (Number(this.props.ON) < this.props.Xvoltage) {
                    angleInRadians = Math.atan((100 - dimmingLevel) / ((this.props.Yvoltage - this.props.Xvoltage) * 10));
                    opposite = (this.props.ON - this.props.Xvoltage) * 10 * Math.tan(angleInRadians);
                }

                if (this.props.Xvoltage > Number(this.props.OFF)) {
                    opposite_small = (offPoint - xPoint) * 10 * Math.tan(angleInRadians);
                    temp1_point = offPoint;
                    show_l4 = false;
                }
            }

        }

        const L1_1 = [
            {x: temp3_point, y: 0},
            {x: this.props.ON, y: 0}
        ];
        let L1 = [];
        if (xPoint < yPoint) { //Positive
            // do nothing
            L1.push({x: temp3_point, y: 0});
            L1.push({x: this.props.ON, y: 0});
        } else { //Negative
            if (this.props.enableAirborne !== "1") { //No Airborne
                // do nothing
                L1.push({x: temp3_point, y: 0});
                L1.push({x: this.props.ON, y: 0});
            } else { //Negative + Airborne
                if (this.props.OFF === 'Off') { //Negative + Airborne + No Dim2OFF
                    if (this.props.outputSettingsWhenAirborne === 'Maximum Output Current') { //
                        // do nothing
                        L1.push({x: temp3_point, y: 0});
                        L1.push({x: this.props.ON, y: 0});
                    } else if (this.props.outputSettingsWhenAirborne === 'Minimum Output Current') {
                        // do nothing
                        L1.push({x: temp3_point, y: 0});
                        L1.push({x: this.props.ON, y: 0});
                    } else if (this.props.outputSettingsWhenAirborne === 'Consistent with the dimming logic') {
                        // do nothing
                        L1.push({x: temp3_point, y: 0});
                        L1.push({x: this.props.ON, y: 0});
                    }
                } else { //Negative + Airborne + YES Dim2OFF
                    if (this.props.outputSettingsWhenAirborne === 'Maximum Output Current') { //
                        L1.push({x: this.props.ON, y: 0});
                        L1.push({x: this.props.airbornVoltage, y: 0});
                        L1.push({x: this.props.airbornVoltage, y: 100});
                        L1.push({x: temp3_point, y: 100});
                    } else if (this.props.outputSettingsWhenAirborne === 'Minimum Output Current') {
                        // do nothing
                        L1.push({x: temp3_point, y: 0});
                        L1.push({x: this.props.ON, y: 0});
                    } else if (this.props.outputSettingsWhenAirborne === 'Consistent with the dimming logic') {
                        // do nothing
                        L1.push({x: temp3_point, y: 0});
                        L1.push({x: this.props.ON, y: 0});
                    }
                }
            }
        }

        const L2 = [
            {x: this.props.ON, y: 0},
            {x: this.props.ON, y: opposite + dimmingLevel},
        ];

        const L3 = [
            {x: offPoint, y: 0},
            {x: offPoint, y: dimmingLevel + opposite_small},
        ];

        let L4 = [];
        if (xPoint < yPoint) { //Positive
            // do nothing
            L4.push({x: offPoint, y: dimmingLevel});
            L4.push({x: xPoint, y: dimmingLevel});
        } else { //Negative
            if (this.props.enableAirborne !== "1") { //No Airborne
                // do nothing
                L4.push({x: offPoint, y: dimmingLevel});
                L4.push({x: xPoint, y: dimmingLevel});
            } else { //Negative + Airborne
                if (this.props.OFF === 'Off') { //Negative + Airborne + No Dim2OFF
                    if (this.props.outputSettingsWhenAirborne === 'Maximum Output Current') { //
                        L4.push({x: xPoint, y: dimmingLevel});
                        L4.push({x: this.props.airbornVoltage, y: dimmingLevel});
                        L4.push({x: this.props.airbornVoltage, y: 100});
                        L4.push({x: offPoint, y: 100});
                    } else if (this.props.outputSettingsWhenAirborne === 'Minimum Output Current') {
                        // do nothing
                        L4.push({x: offPoint, y: dimmingLevel});
                        L4.push({x: xPoint, y: dimmingLevel});
                    } else if (this.props.outputSettingsWhenAirborne === 'Consistent with the dimming logic') {
                        // do nothing
                        L4.push({x: offPoint, y: dimmingLevel});
                        L4.push({x: xPoint, y: dimmingLevel});
                    }
                } else { //Negative + Airborne + YES Dim2OFF
                    if (this.props.outputSettingsWhenAirborne === 'Maximum Output Current') { //
                        // do nothing
                        L4.push({x: offPoint, y: dimmingLevel});
                        L4.push({x: xPoint, y: dimmingLevel});
                    } else if (this.props.outputSettingsWhenAirborne === 'Minimum Output Current') {
                        // do nothing
                        L4.push({x: offPoint, y: dimmingLevel});
                        L4.push({x: xPoint, y: dimmingLevel});
                    } else if (this.props.outputSettingsWhenAirborne === 'Consistent with the dimming logic') {
                        // do nothing
                        L4.push({x: offPoint, y: dimmingLevel});
                        L4.push({x: xPoint, y: dimmingLevel});
                    }
                }
            }
        }

        // affected by Airborne

        let L5 = [];
        L5.push({x: this.props.Yvoltage, y: 100});
        if (xPoint < yPoint) { //Positive
            if (this.props.enableAirborne !== "1") { //No Airborne
                L5.push({x: temp2_point, y: 100}); //do nothing
            } else { //Positive + Airborne
                if (this.props.OFF === 'Off') { //Positive + Airborne + No Dim2OFF
                    if (this.props.outputSettingsWhenAirborne === 'Maximum Output Current') { //
                        L5.push({x: temp2_point, y: 100});
                    } else if (this.props.outputSettingsWhenAirborne === 'Minimum Output Current') {
                        L5.push({x: this.props.airbornVoltage, y: 100});
                        L5.push({x: this.props.airbornVoltage, y: this.props.MinDim});
                        L5.push({x: 12, y: this.props.MinDim});
                    } else if (this.props.outputSettingsWhenAirborne === 'Consistent with the dimming logic') {
                        L5.push({x: temp2_point, y: 100}); //do nothing
                    }
                } else { //Positive + Airborne + YES Dim2OFF
                    if (this.props.outputSettingsWhenAirborne === 'Maximum Output Current') { //
                        L5.push({x: temp2_point, y: 100});
                    } else if (this.props.outputSettingsWhenAirborne === 'Minimum Output Current') {
                        L5.push({x: this.props.airbornVoltage, y: 100});
                        L5.push({x: this.props.airbornVoltage, y: 0});
                        L5.push({x: 12, y: 0});
                    } else if (this.props.outputSettingsWhenAirborne === 'Consistent with the dimming logic') {
                        L5.push({x: temp2_point, y: 100}); //do nothing
                    }
                }
            }
        } else { //Negative
            L5.push({x: temp2_point, y: 100}); //do nothing
        }

        const L6_x0 = Number(this.props.Yvoltage);
        const L6_y0 = 100;
        const L6_x1 = Number(temp1_point);
        const L6_y1 = dimmingLevel + opposite_small;

        let L6;
        if (this.props.curveType === 'Logarithmic') {
            L6 = [];
            const steps = 20;
            for (let i = 0; i <= steps; i++) {
                const t = i / steps;
                const tCurved = Math.log(1 + 9 * t) / Math.log(10);
                L6.push({
                    x: L6_x0 + (L6_x1 - L6_x0) * t,
                    y: L6_y0 + (L6_y1 - L6_y0) * tCurved,
                });
            }
        } else {
            L6 = [
                {x: L6_x0, y: L6_y0},
                {x: L6_x1, y: L6_y1},
            ];
        }

        return (
            <div className="ChartsOne">
                <FlexibleXYPlot
                    height={400} width={600} xDomain={[0, 12]} yDomain={[0, 100]}
                >
                    <HorizontalGridLines/>
                    <VerticalGridLines/>
                    <XAxis
                        title="Dimming Voltage(V)"
                        tickValues={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]} // Specify exact tick values
                        tickFormat={(v) => `${v}V`} // Format tick labels
                    />
                    <YAxis
                        title="Dimming Level(%)"
                        tickValues={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]} // Specify exact tick values
                        tickFormat={(v) => `${v}%`} // Format tick labels
                    />

                    {show_l1 ? <LineSeries data={L1} color={"blue"}/> : null}
                    {show_l2 ? <LineSeries data={L2} color={"blue"}/> : null}
                    {show_l3 ? <LineSeries data={L3} color={"blue"}/> : null}
                    {show_l4 ? <LineSeries data={L4} color={color_l4}/> : null}
                    <LineSeries data={L5} color={"red"}/>
                    <LineSeries data={L6} color={"red"}/>

                    <CustomSVGSeries
                        className="custom-marking"
                        customComponent={(row, positionInPixels) => {
                            return (
                                <g className="inner-inner-component">
                                    <circle cx="0" cy="0" r={2} fill="green"/>
                                    <text x={0} y={0}>
                                        <tspan x="0" y="0">{`X(${xPoint}, ${dimmingLevel}%)`}</tspan>
                                    </text>
                                </g>
                            );
                        }}
                        data={[
                            {x: xPoint, y: dimmingLevel, size: 1},
                        ]}
                    />

                    <CustomSVGSeries
                        className="custom-marking"
                        customComponent={(row, positionInPixels) => {
                            return (
                                <g className="inner-inner-component">
                                    <circle cx="0" cy="0" r={2} fill="green"/>
                                    <text x={0} y={0}>
                                        <tspan x="0" y="0">{`Y(${yPoint}, ${100}%)`}</tspan>
                                    </text>
                                </g>
                            );
                        }}
                        data={[
                            {x: yPoint, y: 100, size: 1},
                        ]}
                    />

                    {show_l1 ?
                        <CustomSVGSeries
                            className="custom-marking"
                            customComponent="diamond"
                            data={[
                                {
                                    x: this.props.ON,
                                    y: opposite + dimmingLevel,
                                    value: 12,
                                    size: 10,
                                    style: {stroke: 'blue', fill: 'blue'}
                                },
                                {x: offPoint, y: 3, value: 12, size: 10, style: {stroke: 'blue', fill: 'blue'}},
                            ]}
                        /> : null}

                    {totalErrors > 0 ?
                        <CustomSVGSeries
                            className="custom-marking"
                            customComponent={(row, positionInPixels) => {
                                return (
                                    <g className="inner-inner-component">
                                        <text x={0} y={0}>
                                            <tspan x="0" y="0">{`Unsupported Value`}</tspan>
                                        </text>
                                    </g>
                                );
                            }}
                            data={[
                                {x: 1, y: 50, size: 10},
                            ]}
                        /> : null}

                </FlexibleXYPlot>
            </div>
        );
    };
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
        issues: state.project.issueByProperty,
    };
};

export default connect(
    mapStateToProps
)(AdjustableDimChart);
